/**
 *
 * TABLE OF CONTENTS
 * Use @ along with function name to search for the directive.
 *
 *  @pageTitle - Page Title Directive for page title name
 *  @widgetToggle - Directive to toggle widgets
 *  @widgetClose - Directive to close widget
 *  @toggleLeftSidebar - Left Sidebar Directive to toggle sidebar navigation
 *  @toggleRightSidebar - Right Sidebar Directive to toggle sidebar navigation
 *  @navToggleSub - Directive to toggle sub-menu down
 *  @slider - Directive to run bootstrap sliders
 *  @gaugejs - Directive for the gauge graph
 *  @css3animate - css3 animations
 *  @mapUsa - Directive for vector map
 *  @iCheck - Directive for custom checkboxes
 *  @skycon - Directive for skycons
 *  @dropZone - Directive for multifile uploader
 *  @barchart - Directive for morris/barchart
 *  @linechart - Directive for morris/linechart
 *  @donutchart - Directive for morris/donutchart
 *  @sparkline - Directive for sparkline chart
 *  @fullscreenMode - Directive for fullscreen browsers
 *  @fullscreenWidget - Directive for fullscreen widgets
 *  @listGroupSelector - Add selected class to clicked item and remove active class from all other children
 *  @buttonGroupSelector - Add success class to clicked item and remove default class from selected item
 *
 */

/*
 * @pageTitle - Page Title Directive for page title name
 */
function pageTitle($rootScope, $timeout) {
    return {
        link: function(scope, element) {
            var listener = function(event, toState, toParams, fromState, fromParams) {
                var title = (typeof(event.currentScope) != 'undefined' && typeof(event.currentScope.appTitle) != 'undefined') ? event.currentScope.appTitle : '';
                if (typeof(toState.label) != 'undefined') {
                    title = title + ' | ' + toState.label.capitalizeFirstLetter();
                }
                else if (typeof(toState.name) != 'undefined')
                {
                    title = title + ' | ' + toState.name.capitalizeFirstLetter();
                }
                $timeout(function() {
                    element.text(title);
                });
            };
            $rootScope.$on('$stateChangeStart', listener);
        }
    }
};

/**
 * @widgetToggle - Directive to toggle widget
 */
function widgetToggle() {
    return {
        restrict: 'A',
        link: function(scope, element) {
            element.click(function() {
                $(this).parent().parent().next().slideToggle("fast"), $(this).toggleClass("fa-chevron-down fa-chevron-up")
            });
        }
    }
};
/**
 * @widgetHeaderToggle - Directive to toggle widget by clicking on its header
 */
function widgetHeaderToggle() {
    return {
        restrict: 'A',
        link: function(scope, element) {
            element.click(function() {
                $(this).next().slideToggle("fast"), $(this).find("i.fa-chevron-down, i.fa-chevron-up").toggleClass("fa-chevron-down fa-chevron-up");
            });
        }
    }
};
/**
 * @widgetClose - Directive to close widget
 */
function widgetClose() {
    return {
        restrict: 'A',
        link: function(scope, element) {
            element.click(function() {
                $(this).parent().parent().parent().fadeOut()
            });
        }
    }
};

/*
 * @toggleLeftSidebar - Left Sidebar Directive to toggle sidebar navigation
 */
function toggleLeftSidebar() {
    return {
        restrict: 'A',
        template: '<button ng-click="toggleLeft()" class="sidebar-toggle" id="toggle-left"><i class="fa fa-bars"></i></button>',
        controller: function($scope, $element) {
            $scope.toggleLeft = function() {
                ($(window).width() > 767) ? $('#main-wrapper').toggleClass('sidebar-mini'): $('#main-wrapper').toggleClass('sidebar-opened');
                setTimeout(function(){$(window).trigger('resize');}, 200);
            }
        }
    };
}

/*
 * @toggleRightSidebar - Right Sidebar Directive to toggle sidebar navigation
 */
function toggleRightSidebar() {
    return {
        restrict: 'A',
        template: '<button ng-click="toggleRight()" class="sidebar-toggle btn btn-white page-filters" id="toggle-right"><i class="fa fa-comments"></i></button>',
        controller: function($scope, $element) {
            $scope.toggleRight = function() {
                $('#sidebar-right').toggleClass("sidebar-right-open");
                $("#toggle-right .fa").toggleClass("fa-indent fa-dedent");
            }
        }
    };
};

/*
 * @closeRightSidebar - Right Sidebar Directive to toggle sidebar navigation
 */
function closeRightSidebar() {
    return {
        restrict: 'A',
        template: '<a ng-click="toggleRight()" class="btn btn-xs btn-close sidebar-close"><i class="fa fa-times"></i></a>',
        controller: function($scope, $element) {
            $scope.toggleRight = function() {
                $('#sidebar-right').toggleClass("sidebar-right-open");
                $("#toggle-right .fa").toggleClass("fa-indent fa-dedent");
            }
        }
    };
};

/**
 * @navToggleSub - Directive to toggle sub-menu down
 */
function navToggleSub($rootScope, $timeout) {
    return {
        restrict: 'A',
        link: function(scope, element) {

        	var addNavgoco = function() {
        		 element.navgoco({
                     caretHtml: false,
                     accordion: true
                 })
            };

            //invoke when view is rendered
            $timeout(function() {
            	addNavgoco();
	        }, 1000);

        }
    };
};

/**
 * @sliders - Directive to run bootstrap sliders
 */
function slider() {
    return {
        restrict: 'A',
        link: function(scope, element) {
            element.slider();
        }
    }
};

/**
 * @css3animate - css3 animations
 */
function css3animate() {
    return {
        restrict: 'A',
        link: function(scope, element) {
            element.click(function() {
                var animate = $(this).attr("data-animated");
                $(this).closest('.panel').addClass(animate).delay(1000).queue(function(next) {
                    $(this).removeClass(animate);
                    next();
                })
            })
        }
    }

};

/**
 * @iCheck - Directive for custom checkboxes
 */
function ichecks($timeout, $parse) {
    return {
        link: function(scope, element, attrs) {
            return $timeout(function() {

                scope.$watch(attrs['ngDisabled'], function (newValue) {
                    $(element).iCheck(newValue ? 'disable' : 'enable');
                    $(element).iCheck('update');
                })

                return $(element).iCheck({
                    checkboxClass: 'icheckbox_flat-grey',
                    radioClass: 'iradio_flat-grey',
                    increaseArea: '20%'
                }).on('ifChanged', function(event) {
                    if ($(element).attr('type') === 'checkbox' ) {
                        //scope.$apply(function() {});
                    }
                    if ($(element).attr('type') === 'radio' ) {
                        //scope.$apply(function() {});
                    }
                });
            });
        }
    };
};

/**
 * @skycon - Directive for skycons
 */
function skycon() {
    return {
        restrict: 'A',
        link: function(scope, element, attrs) {
            var skycons = new Skycons({
                'color': (attrs.color || '#27B6AF')
            });
            element.html('<canvas width="' + attrs.width + '" height="' + attrs.height + '"></canvas>');
            skycons.add(element.children()[0], attrs.skycon);
            skycons.play()
        }
    }
};


/**
 * @fullscreenMode - Directive for fullscreen browsers
 */

function fullscreenMode() {
    return {
        restrict: 'A',
        template: '<button ng-click="toggleFullscreen()" type="button" id="toggle-fullscreen"><i class="fa fa-expand"></i></button>',
        controller: function($scope, $element) {
            $scope.toggleFullscreen = function() {
                $(document).toggleFullScreen()
                $('#toggle-fullscreen .fa').toggleClass('fa-expand fa-compress');
                setTimeout(function(){$(window).trigger('resize');}, 200);
            }
        }
    };
};

/**
 * @fullscreenWidget - Directive for fullscreen widgets
 */

function fullscreenWidget() {
    return {
        restrict: 'A',
        link: function(scope, element) {
            element.click(function() {
                var panel = $(this).closest('.panel');
                panel.toggleClass('widget-fullscreen');
                $(this).toggleClass('fa-expand fa-compress');
                $('body').toggleClass('fullscreen-widget-active')
                setTimeout(function(){$(window).trigger('resize');}, 200);
            });
        }
    }
};

/**
 * @listGroupSelector - Add selected class to clicked item and remove active class from all other children
 */
function listGroupSelector() {
    return {
        restrict: 'A',
        link: function(scope, element) {
            element.click(function() {
            	$(element).closest('.list-group-root').find('.list-group-item').removeClass('selected');
            	$(element).addClass('selected');

//            	//if superset if exists
//            	var supersetcontainer = $(element).closest('.tab-pane').find('.superset-list');
//            	if(supersetcontainer.length > 0)
//            	{
//            		//reset selection
//	            	//$(supersetcontainer).find('.btn-success').removeClass('btn-success').addClass('btn-default');
//
//	            	//click the first item if nothing selected
//	            	if($(supersetcontainer).find('.btn-selected').length == 0)
//	            	{
//	            		//$(supersetcontainer).find('button:eq(0)').click();
//	            	}
//            	}
            });
        }
    }
};

/**
 * @listGroupSelector - Add selected class to clicked item and remove active class from all other children
 */
function buttonGroupSelector() {
    return {
        restrict: 'A',
        link: function(scope, element) {
            element.click(function() {
            	if(!$(element).hasClass('selected')&&!$(element).hasClass('btn-inactive'))
            	{
            		$(element).closest('.list-group').find('.btn-success').removeClass('btn-success').addClass('btn-default').find('i').removeClass('fa-check');
            		$(element).removeClass('btn-default').addClass('btn-success');
            	}
            });
        }
    }
};

/**
 * @simpleTable - Directive for rendering a normal html table
 */
function simpleTable($compile,$timeout) {
	return {
		restrict: 'A',
		link: function (scope, element, attrs,ctrl) {
			var tableId = attrs.id;
			var unregister = scope.$watch(tableId + '.data', function () {
				if(typeof(scope[tableId].data) !== 'undefined')
				{
					//construct table body
					var html = '';
					var tableData = scope[tableId].data;
					var tableStyles = typeof scope[tableId].config.inline_styles != 'undefined' ? scope[tableId].config.inline_styles : null;
					var headers = '';
					var i = 0;

					var header_class = '';
					if(typeof(scope[tableId].config.header_class) !== 'undefined')
					{
						header_class = scope[tableId].config.header_class;
					}

					angular.forEach(tableData, function(row, row_key){
						if(i==0)
						{
							//Add table header data
							headers += '<tr class="'+header_class+'">';
							angular.forEach(row, function(cell, cell_key){
								var styles = tableStyles !== null && typeof tableStyles[cell_key] != 'undefined'? tableStyles[cell_key]:'';
								var styles_html = '';
								if(styles !== '')
								{
									styles_html = ' style="'+styles+'"';
								}
								headers += '<th'+styles_html+'>'+cell+'</th>';
							});
							headers += '</tr>';
						}
						else
						{
                            var selected = "";
                            if(row.row_properties && row.row_properties.selected == true)
                            {
                                selected = "selected";
                            }
                            //Add data for the table body
                            html += '<tr class="'+selected+'">';
                            angular.forEach(row, function(cell, cell_key)
                            {
                                if(cell_key == 'row_properties')
                                {
                                    // continue;
                                }
                                //Check if the cell data is an object or a string
                                else if(typeof cell =='object')
                                {
									// It is an object, check for format options
									var value = (cell != null && typeof cell.value !='undefined')?cell.value:'';
									var compare = (cell != null && typeof cell.compare !='undefined')?cell.compare:'';
									var top_or_bottom = (cell != null && typeof cell.top_or_bottom !='undefined')?cell.top_or_bottom:'';
									var className = (cell != null && typeof cell.className !='undefined')?cell.className:'';
                                    var styles = tableStyles !== null && typeof tableStyles[cell_key] != 'undefined'? tableStyles[cell_key]:'';
                                    var styles_html = '';
                                    if(styles !== '')
                                    {
                                        styles_html = ' style="'+styles+'"';
                                    }
									var cell_pre_html = '';
									var cell_post_html = '';
									if(top_or_bottom !== '')
									{
										cell_pre_html += top_or_bottom;
									}
									if(compare !== '')
									{
										cell_post_html += compare;
									}

									value = value !== '' ? value : ' - ';
									html += '<td '+styles_html+' class="' + className + '"><div class="display-inline">'+cell_pre_html+'</div><div class="compare-cell-score">'+value+'</div><div class="display-inline">'+cell_post_html+'</div></td>';
								}
								else
								{
									cell = cell !== '' ? cell : ' - ';
									var styles = tableStyles !== null && typeof tableStyles[cell_key] != 'undefined'? tableStyles[cell_key]:'';
									var styles_html = '';
									if(styles !== '')
									{
										styles_html = ' style="'+styles+'"';
									}
									html += '<td '+styles_html+'>'+cell+'</td>';
								}
							});
							html += '</tr>';
						}
						i++;
					});
					$(element).find('thead').html(headers);
					$(element).find('tbody').html(html);
				}
			});
		}
	}
}

/**
 * @renderDataBlock - Directive for rendering a normal data block
 */
function renderDataBlock($compile, $timeout) {
    return {
        restrict: 'A',
        link: function (scope, element, attrs,ctrl) {
            var blockId = attrs.id;
            var unregister = scope.$watch(blockId + '.data', function () {
                if(typeof(scope[blockId]) !== 'undefined' && typeof(scope[blockId].data) !== 'undefined')
                {
                    //construct block body
                    var html = '';
                    var blockData = scope[blockId].data;
                    var count = Object.keys(blockData).length;;
                    angular.forEach(blockData, function(row, row_key)
                    {
                        var split = count<=6?Math.round(12/count):4;//calculate the split size for each vertical grid
                        var label = typeof row.label != 'undefined'? row.label: '';
                        var value = typeof row.value != 'undefined'? row.value: '';
                        var compare = (row != null && typeof row.compare !='undefined')?row.compare:'';
                        var cell_post_html = '';
                        if(compare !== '')
                        {
                            cell_post_html += '&nbsp;' + compare;
                        }
                        html += '<div class="col-md-'+split+' col-sm-'+split+' pad-15 text-center status_block">';
                        html +=    '<span class="lead">'+value+cell_post_html+'</span>';
                        html +=    '<p>'+label+'</p>';
                        html += '</div>';
                    });
                    $(element).html(html);
                }
            });
        }
    }
}

/**
 * @renderDataBlock - Directive for rendering a normal data block
 */
function renderActionPlanForm($compile, $timeout) {
    return {
        restrict: 'A',
        link: function (scope, element, attrs,ctrl) {
            var blockId = attrs.attrid;
            var watchElementGroup = [
              blockId + '.data',
              'action_plan_details'
            ];

            var unregister = scope.$watchGroup(watchElementGroup, function () {
                if(typeof(scope[blockId]) != 'undefined' && typeof(scope[blockId].data) !== 'undefined')
                {
                    //construct block body
                    var serial_no_enabled = typeof(scope[blockId]['config']['add_serial_number']) != 'undefined' ? true : false;
                    var html = '';
                    var formData = scope[blockId].data;
                    var actionPlanDefaultData = scope.$parent.$parent['action_plan_details'];
                    
                    var action_plan_doc_download_url = scope.$parent.$parent['action_plan_doc_download_url'];
                    var end_time = typeof(scope.$parent.$parent['current_time_period_obj']) != 'undefined' ? scope.$parent.$parent['current_time_period_obj']['to'] : null;
                    var validationAttributes = [];
                    if(typeof(actionPlanDefaultData) != 'undefined' && actionPlanDefaultData != null && actionPlanDefaultData != '')
                    {
                        var count = Object.keys(formData).length;
                        var priorities = actionPlanDefaultData['details']['priorities'];
                        var firstItem = 0;

                        if(typeof(actionPlanDefaultData.id) != 'undefined')
                        {
                            html += '<input type="hidden" value="'+actionPlanDefaultData.id+'" name="plan_id_'+actionPlanDefaultData['survey_key']+'" />'
                        }

                        angular.forEach(formData, function(row, row_key)
                        {
                            if(firstItem > 0)
                            {
                                var priority_title = (serial_no_enabled === true) ?  row[1].toLowerCase() : row[0].toLowerCase();
                                angular.forEach(priorities, function(priority_row, priority_row_key)
                                {
                                    if(priority_title == priority_row_key.toLowerCase())
                                    {
                                        html += '<div class="panel panel-default">';
                                        html += '<div class="panel-heading" href="#collapse_'+priority_row.priority_id+'">';
                                        html += '<div class="panel-title pull-left" style="font-size:14px;">'+firstItem+' - '+priority_row_key+'</div>';
                                        html += '<div class="clearfix"></div>';
                                        html += '</div>'; 

                                        html += '<div class="panel-body" id="collapse_'+priority_row.priority_id+'">';
                                        html += '<div class="">';
                                        angular.forEach(priority_row['actions'], function(action_row, action_row_key)
                                        {
                                            var validation_rule = {};
                                            html += '<div class="row form-group">';
                                            html += '<div class="col-md-8">';
                                            
                                            if(action_row['input_type'] == 'checkbox')
                                            {
                                                html += '<input ichecks class="icheck" type="checkbox"';
                                                if(typeof(action_row['selected']) != 'undefined' && action_row['selected'] == true)
                                                {
                                                    html += 'checked="checked"';
                                                }
                                                html += ' name="checkbox_'+action_row['priority_id']+'[]" value="'+action_row['id']+'" />';
                                                html += '<span class="checkbox_description">'+action_row_key+'</span>';
                                                validation_rule = {
                                                    "type": "checkbox",
                                                    "id": action_row['id'],
                                                    "element_name": "checkbox_"+action_row['priority_id'],
                                                    "multiple_input": true,
                                                    "required": "at_least_one",
                                                    "error_message": "Atleast one action must be selected for each priority"
                                                };
                                                if(action_row['input_type_on_select'] == 'textbox')
                                                {
                                                    validation_rule.other_value_exist = true;
                                                    validation_rule.other_value = action_row['id'];
                                                    validation_rule.other_value_element = 'other_'+action_row['priority_id']+'_'+action_row['id'];
                                                    validation_rule.other_error_message = "Please specify the 'Other' Action's value";

                                                    html += '<input class="form-control" style="display: inline-block;width: 70%;margin-left: 14px;" type="textbox"';
                                                    if(typeof(action_row['others_specified']) != 'undefined')
                                                    {
                                                        html += 'value="'+action_row['others_specified']+'"';
                                                    }
                                                    html += ' name="other_'+action_row['priority_id']+'_'+action_row['id']+'"/>';
                                                }
                                                // console.log(validation_rule);
                                                validationAttributes.push(validation_rule);
                                            }

                                            html += '</div>'; 
                                            html += '<div class="col-md-2">';
                                            validation_rule = {
                                                //"type": "select",
                                                "type": "textbox",
                                                "id": action_row['id'],
                                                "element_name": "advisor_"+action_row['priority_id']+"_"+action_row['id'],
                                                "dependent_element": "checkbox_"+action_row['priority_id'],
                                                "required": true,
                                                "error_message": "Responsible person must be entered for each selected action"
                                            };
                                            html += '<input class="form-control" placeholder="Responsible" type="textbox"';
                                            if(typeof(action_row['selected_user']) != 'undefined')
                                            {
                                                html += 'value="'+action_row['selected_user']+'"';
                                            }
                                            html += ' name="advisor_'+action_row['priority_id']+'_'+action_row['id']+'"/>';
                                            /*html += '<select name="advisor_'+action_row['priority_id']+'_'+action_row['id']+'" class="form-control">';
                                            html += '<option value="">Select</option>';
                                            if(typeof(actionPlanDefaultData.advisors) != 'undefined')
                                            {
                                                angular.forEach(actionPlanDefaultData.advisors, function(advisor_name, advisor_key)
                                                {
                                                    if(typeof(action_row['selected_user']) != 'undefined' && action_row['selected_user'] == advisor_name['advisor'])
                                                    {
                                                        html += '<option selected value="'+advisor_name['advisor']+'">'+advisor_name['advisor']+'</option>';
                                                    }
                                                    else
                                                    {
                                                        html += '<option value="'+advisor_name['advisor']+'">'+advisor_name['advisor']+'</option>';
                                                    }
                                                });
                                            }
                                            html += '</select>';*/

                                            validationAttributes.push(validation_rule);
                                            html += '</div>';
                                            html += '<div class="col-md-2">';
                                            validation_rule = {
                                                "type": "text",
                                                "id": action_row['id'],
                                                "element_name": "datepicker_"+action_row['priority_id']+"_"+action_row['id'],
                                                "dependent_element": "checkbox_"+action_row['priority_id'],
                                                "required": true,
                                                "error_message": "Due date must be entered for each selected action"
                                            };

                                            html += '<input readonly="true" class="form-control" to_date='+end_time+' style="width:100%"';

                                            if(typeof(action_row['due_date']) != 'undefined' && action_row['due_date'] != '')
                                            {
                                                var selected_date = new Date(action_row['due_date'] * 1000);
                                                var d = selected_date.getUTCDate().toString(),
                                                m = (selected_date.getUTCMonth() + 1).toString(),
                                                y = selected_date.getUTCFullYear().toString(), 
                                                formattedDate = '';
                                                if (d.length === 1) { // pad to two digits if needed
                                                    d = '0' + d;
                                                }
                                                if (m.length === 1) { // pad to two digits if needed
                                                    m = '0' + m;
                                                }
                                                formattedDate = d + '/' + m + '/' + y; 
                                                html += ' value="'+formattedDate+'" ng-init="datevalue_'+action_row['priority_id']+'_'+action_row['id']+' = \''+formattedDate+'\'" ';
                                            }
                                            html += ' type="text" name="datepicker_'+action_row['priority_id']+'_'+action_row['id']+'" id="datepicker_'+action_row['priority_id']+'_'+action_row['id']+'" mydatepicker ng-model="datevalue_'+action_row['priority_id']+'_'+action_row['id']+'" />';
                                            html += '<label class="icn-datepicker" for="datepicker_'+action_row['priority_id']+'_'+action_row['id']+'"><span class="fa fa-calendar open-datetimepicker"></span></label>';
                                            //html += '<div class="icn-datepicker"><i class="fa fa-calendar"></i></div>';//button for datepicker
                                            validationAttributes.push(validation_rule);
                                            //html += '<datepicker><input ng-model="date" type="text" style="width:100px;" date-format=""/></datepicker>';
                                            html += '</div>';
                                            html += '</div>';
                                        });
                                        html += '<div class="form-group row">';
                                        //Validate textarea
                                        validation_rule = {
                                            "type": "textarea",
                                            "element_name": "notes_"+priority_row.priority_id,
                                            "multiple_input": false,
                                            "required": true,
                                            "error_message": "Implementation notes must be entered for all priorities"
                                        };
                                        html += '<div class="col-md-8"><textarea name="notes_'+priority_row.priority_id+'" placeholder="Implementation Note" class="form-control">';
                                        if(typeof(priority_row['notes']) != 'undefined')
                                        {
                                            html += priority_row['notes'];
                                        }
                                        html += '</textarea></div>';
                                        validationAttributes.push(validation_rule);
                                        //File Input
                                        html += '<div class="col-md-4">';
                                        
                                        if(typeof(actionPlanDefaultData['file_validation']) != 'undefined' && typeof(actionPlanDefaultData['file_validation']['extension']) != 'undefined')
                                        {
                                            var _file_extension = actionPlanDefaultData['file_validation']['extension'];
                                            if(_file_extension.length > 0)
                                            {
                                                _file_extension = _file_extension.join();
                                            }
                                        }

                                        if(typeof(priority_row['uploaded_file']) != 'undefined')
                                        {
                                            html += '<div class="file_name_placeholder" id="file_name_placeholder_'+priority_row.priority_id+'">';
                                            html += '<div syle="text-align:center;">'+priority_row['uploaded_file_actual_name']+' <a class="remove_file" data-fid="'+priority_row.file_id+'" data-file_id="'+priority_row.priority_id+'" href="javascript:void(0)"><i class="fa fa-window-close file" aria-hidden="true"></i></a></div>';
                                            html += '</div>';
                                            html += '<div style="display:none" class="upload-field" id="file_placeholder_'+priority_row.priority_id+'">';
                                            html += '<input onchange="angular.element(this).scope().setFile(this, '+priority_row.priority_id+')" ng-model="formuploaddata.file" type="file" name="file_'+priority_row.priority_id+'" id="file_'+priority_row.priority_id+'" class="inputfile" />';
                                            html += '<button class="btn btn-primary btn-block btn_red">Add File</button>';
                                            if(typeof(_file_extension) != 'undefined'){
                                                 html += '<div style="margin-top: 50px;" class="checkbox_description">Allowed Extensions are '+_file_extension+'</div>';
                                            }
                                            html += '</div>';
                                        }
                                        else
                                        {
                                            html += '<div class="file_name_placeholder" style="display:none" id="file_name_placeholder_'+priority_row.priority_id+'">'
                                            html += '</div>';
                                            html += '<div class="upload-field" id="file_placeholder_'+priority_row.priority_id+'">';
                                            html += '<input onchange="angular.element(this).scope().setFile(this, '+priority_row.priority_id+')" ng-model="formuploaddata.file" type="file" name="file_'+priority_row.priority_id+'" id="file_'+priority_row.priority_id+'" class="inputfile" />';
                                            html += '<button class="btn btn-primary btn-block btn_red">Add File</button>';
                                            if(typeof(_file_extension) != 'undefined'){
                                                 html += '<div style="margin-top: 50px;" class="checkbox_description">Allowed Extensions are '+_file_extension+'</div>';
                                            }
                                            html += '</div>';
                                        }
                                        
                                       
                                        html += '</div>';
                                        /*if(typeof(priority_row['uploaded_file']) != 'undefined')
                                        {
                                            html += '<div id="document_'+priority_row.priority_id+'" class="col-md-8" style="padding:6px;">';
                                            html += '<a style="padding:12px;" class="link_tag" target="_blank" href="'+action_plan_doc_download_url+'?file_id='+priority_row.file_id+'&page=action_plan">'+priority_row.uploaded_file_actual_name+'</a>';
                                            html += '<i title="Click here to delete" ng-click="delete_action_plan_document('+priority_row.file_id+','+priority_row.priority_id+')" class="fa fa-trash fa-2x" aria-hidden="true"></i>';
                                            html += '</div>';
                                        }*/
                                        html += '</div>';
                                        html += '</div>';
                                        html += '</div>';
                                        html += '</div>';
                                    }  
                                });
                                
                            }
                            firstItem += 1;
                        });

                        html += '<div style="text-align: right">';
                        if(typeof(actionPlanDefaultData.expired) != 'undefined' && actionPlanDefaultData.expired == true)
                        {
                            html += '<button style="margin:2px;" type="button" class="btn btn-default btn-theme-default" ng-disabled="disabled">Save</button>';
                            html += '<button style="margin:2px;" type="button" class="btn btn-default btn-theme-default" ng-disabled="disabled">Submit Plan</button>';
                        }
                        else
                        {
                            html += '<button style="margin:2px;" type="button" class="btn btn-default btn-theme-default" ng-click="record_action_plan(\'save\')">Save</button>';
                            html += '<button style="margin:2px;" type="button" class="btn btn-default btn-theme-default" ng-click="record_action_plan(\'submit\')">Submit Plan</button>';
                        }
                        html += '</div>';
                    }
                    // scope.validationAttributes = {"test":validationAttributes};//validationAttributes;
                    scope.$parent.$parent.validationAttributes = validationAttributes;
                    var template = $compile(html)(scope);
                    element.html(template);
                }
            });

            
        }
    }
}

function renderActionPlanActionSection($compile)
{
    return {
        restrict: 'A',
        link: function (scope, element, attrs,ctrl) {
            var type = attrs.type;
            var unregister = scope.$watch('action_plan_details', function () {
                var actionPlanDefaultData = scope.$parent.$parent['action_plan_details'];
                var action_plan_doc_download_url = scope.$parent.$parent['action_plan_doc_download_url'];
                if(typeof(actionPlanDefaultData) != 'undefined' && actionPlanDefaultData != null && actionPlanDefaultData != '')
                {
                    //construct block body
                    var html = '';
                    var validationAttributes = [];
                    if(typeof(actionPlanDefaultData.id) !== 'undefined')
                    {
                        var results = actionPlanDefaultData['details']['results'];
                        var firstItem = 1;

                        angular.forEach(results, function(row, row_key)
                        {
                            html += '<div class="panel panel-default">';
                            html += '<div class="panel-heading">';
                            html += '<div class="panel-title pull-left" style="font-size:14px;">'+firstItem+' - '+row.priority+'</div>';
                            html += '<div class="clearfix"></div>';
                            html += '</div>'; 

                            html += '<div class="panel-body">';
                            html += '<div class="">';
                            angular.forEach(row['actions'], function(action_row, action_row_key)
                            {
                                html += '<div class="form-group row">';
                                if(type == 'submitted')
                                {
                                    html += '<div class="col-md-5 col-lg-6">';
                                }
                                else
                                {
                                    html += '<div class="col-md-8 col-lg-7">';
                                }
                                if(action_row['others_specified'] != '')
                                {
                                    html += '<span class="inline-elements">'+action_row['others_specified']+'</span>';
                                }
                                else
                                {
                                    html += '<span class="inline-elements">'+action_row['action']+'</span>';
                                }
                                html += '</div>'; 


                                html += '<div class="col-md-2 col-lg-2">';
                                html += '<span class="inline-elements">'+action_row['advisor']+'</span>';
                                html += '</div>';

                                if(type == 'submitted')
                                {
                                    html += '<div class="col-md-1 col-lg-1">';
                                }
                                else
                                {
                                    html += '<div class="col-md-2 col-lg-2">';
                                }

                                
                                html += '<span class="inline-elements">'+action_row['due_date']+'</span>';
                                html += '</div>';
                                if(type == 'submitted')
                                {
                                    html += '<div class="col-md-3 col-lg-3">';
                                    var status = action_row['status'].toLowerCase();
                                    if(status == 'pending')
                                    {
                                        if(typeof(actionPlanDefaultData.remaining_days) != 'undefined' && actionPlanDefaultData.remaining_days <= 0)
                                        {
                                            html += '<span class="inline-elements" style="color:#c10001; font-size:13px; padding-left:5px;"><b>Expired</b></span>';
                                        }
                                        else
                                        {
                                            html += '<button class="btn btn-danger action_btn_red" ng-click="mark_as_complete('+row['plan_id']+','+action_row['details_id']+')">'+action_row['button_label']+'</button>';
                                            html += '<span style="color:#c10001; font-size:13px; padding-left:5px;">'+action_row['due_date_message']+'</span>';
                                        }
                                    }
                                    else
                                    {
                                        html += '<button class="btn btn-success action_btn_green">'+action_row['button_label']+'</button>';
                                    }
                                    html += '</div>';
                                }
                                html += '</div>';
                            });
                            html += '<div class="form-group">';
                            html += '<span class="well" style="display:block;font-size:13px;">'+row['notes']+'</span>';
                            html += '</div>';
                            if(typeof(row['uploaded_file']) != 'undefined' && row['uploaded_file'] != '')
                            {
                                html += '<div class="form-group">';
                                html += '<i class="fa fa-paperclip"></i><a class="link_tag" target="_blank" href="'+action_plan_doc_download_url+'?file_id='+row.file_id+'&page=action_plan">'+row.uploaded_file_actual_name+'</a>';
                                html += '</div>';
                            }
                            html += '</div>';
                            html += '</div>';
                            html += '</div>';

                            firstItem += 1;
                        });
                    }
                    var template = $compile(html)(scope);
                    element.html(template);
                }
            });

        }
    }
}


function customFunction($compile,$timeout,$location)
{
	 return {
		 restrict: 'A',
		 link: function (scope, element, attrs,ctrl) {
			 var funcName = typeof(attrs.customFunction) != 'undefined' ? attrs.customFunction : null;
			 var funcTrigger = typeof(attrs.customFunctionTrigger) != 'undefined' ? attrs.customFunctionTrigger : null;

			 if(funcName != null && funcTrigger != null)
		     {
				if(funcTrigger == 'triggernow')
				{
					if(typeof(window[funcName]) == 'function')
					{
						window[funcName](scope, element, attrs, ctrl, $compile, $timeout, $location);
					}
				}
				else
				{
					element.bind(funcTrigger, function() {
						if(typeof(window[funcName]) == 'function')
						{
							window[funcName](scope, element, attrs, ctrl, $compile, $timeout, $location);
						}
	     			});
				}
		     }

	     }
	 }
}

/**
 * @pagefilter - Directive for diaplaying the page filter
 */
function pagefilter($compile,$timeout) {
    return {
        restrict: 'A',
        link: function (scope, element, attrs,ctrl) {
        	var filterKey = attrs.id;

        	if(typeof(scope[filterKey]) != 'undefined')
        	{
        		if(scope[filterKey].filter_type == 'clickselect')
        		{
        			element.bind('click', function() {
        				scope[filterKey].selected_value = (scope[filterKey].selected_value == 1) ? '' : 1;
        				scope.appState.page_filters[filterKey] = scope[filterKey].selected_value;
        				scope.$apply();
        			});
        		}
        		else if(scope[filterKey].filter_type == 'enterkey')
                {
                    var template = $compile('<i id="'+filterKey+'_field_clear" ng-show="'+filterKey+'.selected_value" ng-mousedown="reset($event,\''+filterKey+'\')" class="fa fa-times-circle"></i>')(scope);
                    element.after(template);

                    scope.reset = function(event2, filter_key) {
                        scope[filter_key].selected_value = "";
                        //trigger an enter keypress
                        $timeout(function() {
                            var e = $.Event("keydown");
                            e.which = 13;
                            element.trigger(e);
                        }, 0, false);
                        event2.preventDefault();
                    };

                    element.bind("keydown keypress", function (event) {
                        if(event.which === 13)
                        {
                            //if belongs to a group, update values of all in the group to appState
                            if(typeof(scope[filterKey].group) != 'undefined' && scope[filterKey].group != '')
                            {
                                $.each(scope.appState.page_filters, function(key, value)
                                {
                                    if(typeof(scope[key]) != 'undefined' && scope[key].group == scope[filterKey].group)
                                    {
                                        scope[key].selected_value = $('#'+key).val();
                                        scope.appState.page_filters[key] = scope[key].selected_value;
                                    }
                                });
                            }
                            else //update only the current filter
                            {
                                scope[filterKey].selected_value = $('#'+filterKey).val();
                                scope.appState.page_filters[filterKey] = scope[filterKey].selected_value;
                            }

                            //Scroll to the top of the page
                            if(typeof(scope[filterKey].scrollUpOnSubmit) != 'undefined' && scope[filterKey].scrollUpOnSubmit != ''){
                                $('html, body').animate({scrollTop : 0},800);
                            }

                            scope.$apply();
                            event.preventDefault();
                        }
                    });
                }
                else if(scope[filterKey].filter_type == 'datepicker')
        		{
                    var template = $compile('<i id="'+filterKey+'_field_clear" ng-show="'+filterKey+'.selected_value" ng-mousedown="reset($event,\''+filterKey+'\')" class="fa fa-times-circle"></i>')(scope);
                    element.after(template);

                    var to_date = attrs['toDate'];
                    var from_date = null;
                    var to_date = null;

                    if(typeof scope[filterKey].dependent_min_filter != 'undefined'){
                        //set the min limit
                        target_key = scope[filterKey].dependent_min_filter;
                        target_filter_val = scope[target_key].selected_value;
                        if(target_filter_val){
                            var moment_1 = moment(target_filter_val, "DD/MM/YYYY");
                            from_date = moment_1.toDate();
                        }
                        // console.log(target_filter_val);
                        // console.log(from_date);
                    }
                    if(typeof scope[filterKey].dependent_max_filter != 'undefined'){
                        //Set the max limit
                        target_key = scope[filterKey].dependent_max_filter;
                        target_filter_val = scope[target_key].selected_value;
                        if(target_filter_val){
                            var moment_2 = moment(target_filter_val, "DD/MM/YYYY");
                            to_date = moment_2.toDate();
                        }
                        // console.log(target_filter_val);
                        // console.log(to_date);
                    }

                    // Private variables
                    var datepickerFormat = 'dd/mm/yy',
                        momentFormat = 'D/M/YYYY',
                        datepicker,
                        elPicker;

                    // Init date picker and get objects http://bootstrap-datepicker.readthedocs.org/en/release/index.html
                    datepicker = element.datepicker({
                        autoclose: true,
                        keyboardNavigation: false,
                        todayHighlight: true,
                        dateFormat: datepickerFormat,
                        minDate:from_date,
                        maxDate: to_date,
                        onSelect: function(d,i){
                            if(d !== i.lastVal){
                                $(this).change();

                                //Loop through all the filters and identify the ones dependant on this filter
                                $.each(scope.appState.page_filters, function(key, value)
                                {
                                    //Update any min date dependency
                                    if(typeof(scope[key].dependent_min_filter) != 'undefined' && scope[key].dependent_min_filter == filterKey)
                                    {
                                        var minDate = '';
                                        current_filter_val = scope[filterKey].selected_value;
                                        if(current_filter_val){
                                            var moment_3 = moment(current_filter_val, "DD/MM/YYYY");
                                            minDate = moment_3.toDate();
                                        }
                                        if(minDate != ''){
                                            $('#'+key).datepicker('option', 'minDate', new Date(minDate));
                                        }
                                    }
                                    
                                    //Update any max date dependency
                                    if(typeof(scope[key].dependent_max_filter) != 'undefined' && scope[key].dependent_max_filter == filterKey)
                                    {
                                        var maxDate = '';
                                        current_filter_val = scope[filterKey].selected_value;
                                        if(current_filter_val){
                                            var moment_4 = moment(current_filter_val, "DD/MM/YYYY");
                                            maxDate = moment_4.toDate();
                                        }
                                        if(maxDate != ''){
                                            $('#'+key).datepicker('option', 'maxDate', new Date(maxDate));
                                        }
                                    }
                                });

                                //Check if any config prevents from applying the change to the whole page
                                //Do not trigger the page reload if it will be done explicitly
                                if(typeof scope[filterKey].skip_page_reload_on_change != 'undefined' && scope[filterKey].skip_page_reload_on_change){
                                    //Do nothing
                                }else{
                                    $timeout(function() {
                                        var e = $.Event("keydown");
                                        e.which = 13;
                                        element.trigger(e);
                                    }, 0, false);
                                }
                            }
                        }

                    });

                    scope.reset = function(event2, filter_key) {
                        scope[filter_key].selected_value = "";
                        //trigger an enter keypress
                        $timeout(function() {
                            var e = $.Event("keydown");
                            e.which = 13;
                            element.trigger(e);
                        }, 0, false);
                        event2.preventDefault();
                    };

                    element.bind("keydown keypress", function (event) {
                        if(event.which === 13)
                        {
                            //if belongs to a group, update values of all in the group to appState
                            if(typeof(scope[filterKey].group) != 'undefined' && scope[filterKey].group != '')
                            {
                                $.each(scope.appState.page_filters, function(key, value)
                                {
                                    if(typeof(scope[key]) != 'undefined' && scope[key].group == scope[filterKey].group)
                                    {
                                        scope[key].selected_value = $('#'+key).val();
                                        scope.appState.page_filters[key] = scope[key].selected_value;
                                    }
                                });
                            }
                            else //update only the current filter
                            {
                                scope[filterKey].selected_value = $('#'+filterKey).val();
                                scope.appState.page_filters[filterKey] = scope[filterKey].selected_value;
                            }

                            //Scroll to the top of the page
                            if(typeof(scope[filterKey].scrollUpOnSubmit) != 'undefined' && scope[filterKey].scrollUpOnSubmit != ''){
                                $('html, body').animate({scrollTop : 0},800);
                            }

                            scope.$apply();
                            event.preventDefault();
                        }
                    });
                }
                else if(scope[filterKey].filter_type == 'searchenterkey')
        		{
                    var template = $compile('<i id="'+filterKey+'_field_clear" ng-show="'+filterKey+'.selected_value" ng-mousedown="reset($event,\''+filterKey+'\')" class="fa fa-times-circle clear_btn"></i>'+
                        '<span class="input-group-btn">'+
                        '<button class="btn btn-default btn-search" type="button" ng-click="do_search(\''+filterKey+'\')"><i class="fa fa-search"></i> &nbsp;Search</button>'+
                        '</span>')(scope);
                    element.after(template);

                    scope.reset = function(event2, filter_key) {
                        scope[filter_key].selected_value = "";
                        //trigger an enter keypress
                        $timeout(function() {
                            var e = $.Event("keydown");
                            e.which = 13;
                            element.trigger(e);
                        }, 0, false);
                        event2.preventDefault();
                    };

                    scope.do_search = function(filter_key){
                        // console.log(filter_key);
                        //if belongs to a group, update values of all in the group to appState
                        if(typeof(scope[filterKey].group) != 'undefined' && scope[filterKey].group != '')
                        {
                            $.each(scope.appState.page_filters, function(key, value)
                            {
                                if(typeof(scope[key]) != 'undefined' && scope[key].group == scope[filterKey].group)
                                {
                                    scope[key].selected_value = $('#'+key).val();
                                    scope.appState.page_filters[key] = scope[key].selected_value;
                                }
                            });
                        }
                        else //update only the current filter
                        {
                            scope[filterKey].selected_value = $('#'+filterKey).val();
                            scope.appState.page_filters[filterKey] = scope[filterKey].selected_value;
                        }

                        //Scroll to the top of the page
                        if(typeof(scope[filterKey].scrollUpOnSubmit) != 'undefined' && scope[filterKey].scrollUpOnSubmit != ''){
                            $('html, body').animate({scrollTop : 0},800);
                        }
                    }

        			element.bind("keydown keypress", function (event) {
        				if(event.which === 13)
        				{
        					scope.do_search();
                            scope.$apply();
        					event.preventDefault();
        				}
        			});
        		}
        		else if(scope[filterKey].filter_type == 'dropdown')
        		{
        			var options_field = (typeof(scope[filterKey].options_field) != 'undefined') ? scope[filterKey].options_field : '';
        			var configOptions = scope[filterKey][options_field];
	        		var optionUl = $(element).find('ul:eq(0)');

	        		//if no options are available, hide it
	        		if(jQuery.isEmptyObject(configOptions))
	        		{
	        			$(element).addClass('display-none');
	        			//reset the filter value
	        			if(typeof(scope.appState.page_filters[filterKey]) != 'undefined' && scope.appState.page_filters[filterKey] != '')
	        			{
	        				scope.appState.page_filters[filterKey] = '';
		        			scope.$apply();
	        			}
	        		}
	        		else
	        		{
		        		//add select all to
	        			var all_option = {};
	        			if(typeof(scope[filterKey].no_select_all_option) != 'undefined' && scope[filterKey].no_select_all_option == true)
	        			{
	        				all_option = {};
	        			}
	        			else
	        			{
	        				all_option = {"" : {'label' : scope[filterKey].label}}
	        			}

                        var applySort = false;
                        $.each(configOptions, function(optionKey, optionValue)
                        {
                            if(typeof(optionValue.sort_order) != 'undefined')
                            {
                                applySort = true;
                                return false;
                            }
                        });
                    
                        if(applySort)
                        {
                            configOptions = sortObjectProperties(configOptions, 'sort_order');
                        }

		        		var options = $.extend({}, all_option, configOptions);
                       
	        			$.each(options, function(optionKey, optionValue)
	    				{
                            if(applySort == true && typeof(optionValue.selected_key) != 'undefined')
                            {
                                optionKey = optionValue.selected_key;
                            }

                            if(typeof(optionValue.html_rendering) != 'undefined' && optionValue.html_rendering === false)
                            {
                                return true;
                            }

	        				var optionElement = $('<li><a href="javascript:void(0);">' + optionValue.label + '</a></li>');
	        				optionElement.find('a').bind("click", function (event) {
	        					scope[filterKey].selected_value = optionKey;
	            				scope.appState.page_filters[filterKey] = scope[filterKey].selected_value;
	        					$(element).find('span:eq(0)').html(optionValue.label);

                                //Scroll to the top of the page
                                if(typeof(scope[filterKey].scrollUpOnSubmit) != 'undefined' && scope[filterKey].scrollUpOnSubmit != ''){
                                    $('html, body').animate({scrollTop : 0},800);
                                }
                                
                                //Do not trigger the page reload if it will be done explicitly
                                if(typeof scope[filterKey].skip_page_reload_on_change != 'undefined' && scope[filterKey].skip_page_reload_on_change){
                                    //Do nothing
                                }else{
                                    if(typeof(scope.google_analytics_tracking_code) != 'undefined' && scope.google_analytics_tracking_code != '')
                                    {
                                        var submenu_label = scope.appState.submenu_key;
                                        if(typeof(scope.submenu_labels) != 'undefined' && typeof(scope.submenu_labels[scope.appState.submenu_key]) != 'undefined')
                                        {
                                            submenu_label = scope.submenu_labels[scope.appState.submenu_key].toLowerCase();
                                        }

                                        var _option_label = 'All';
                                        if(typeof(scope[filterKey]['select_options'][optionKey]) != 'undefined')
                                        {
                                            _option_label = scope[filterKey]['select_options'][optionKey]['label'];
                                        }
                                        if(typeof(scope[filterKey]['search_type']) != 'undefined' && scope[filterKey]['search_type'] == 'replace_data_source')
                                        {
                                            if(typeof(scope[filterKey]['metric'][optionKey]) != 'undefined')
                                            {
                                                if(typeof(scope[filterKey]['metric'][optionKey]['label']) != 'undefined')
                                                {
                                                    _option_label = scope[filterKey]['metric'][optionKey]['label'];
                                                }
                                            }
                                        }
                                        gtag('event', scope.appState.page+'_'+submenu_label+'_'+filterKey, {'event_category': scope.appState.page+'_filter', 'event_label': _option_label});
                                    }

                                    scope.$apply();
                                }
	            				
	            				event.preventDefault();
	        				});

	        				//add the select all
	        				if(optionKey == '')
	        				{
	        					optionUl.prepend(optionElement);
	        				}
	        				//add everthing else
	        				else
	        				{
	        					optionUl.append(optionElement);
	        				}

	        				//set initial value
	        				if(optionKey == scope[filterKey].selected_value)
	        				{
	        					$(element).find('span:eq(0)').html(optionValue.label);
	        				}

	    				});
	        		}
        		}
        		else if(scope[filterKey].filter_type == 'tab')
        		{
        			var options_field = (typeof(scope[filterKey].options_field) != 'undefined') ? scope[filterKey].options_field : '';
        			var configOptions = scope[filterKey][options_field];
        			var optionsFound = false;
        			var optionsAvailable = [];

                    var tab_type = typeof attrs.type != 'undefined'? attrs.type:'tabs';

                    var default_select = typeof attrs.defaultSelect != 'undefined'? attrs.defaultSelect:false;

        			var templateHtml = $('<div class="tab-wrapper tab-primary"><tabset type="'+tab_type+'"></tabset></div>');
        			$.each(configOptions, function(optionKey, optionValue)
            		{
        				var tabElement = $('<tab></tab>');
        				tabElement.attr('heading', optionValue.label);
        				tabElement.attr('active', scope[filterKey].selected_value == optionValue.value ? 'true' : 'false');
                        if(default_select)
                        {
                            /*if(default_select != optionValue.value)
                            {
                                tabElement.attr('class', true);
                            }*/
                            tabElement.css('pointer-events', 'none');
                        }
                        else
                        {
                            tabElement.attr('ng-click', "selectPageTab($event,'" + filterKey + "','" + optionValue.value + "')");
                        }
        				
        				//append the content to tab
        				tabElement.html($('#' + filterKey + '_' + optionValue.value).html());

        				//remove the original hidden content
        				$timeout(function() {
        					$('#' + filterKey + '_' + optionValue.value).remove();
        				}, 300);

        				templateHtml.find('tabset').append(tabElement);

        				optionsAvailable.push(optionValue.value);

        				optionsFound = true;
            		});

        			if(optionsFound == true)
        			{
        				$(element).html('').append(templateHtml).removeAttr('pagefilter');//remove attribute to avoid recursion call for pagefilter directive
        				$compile(element)(scope);
        			}

        			scope.selectPageTab = function(event,filterKey, filterValue)
        			{
						//reset other filters if defined in the tab config

						//Get all page filters
						var all_page_filters = scope.appState.page_filters;

						//for every filter dependent on this tab
						$.each(all_page_filters, function( key, value ) {
							var dependent_filters = typeof scope[key]['dependent_filters'] != 'undefined'? scope[key]['dependent_filters']: [];
							var dependent_filter_keys = [];
							for (var i in dependent_filters) {
								if (dependent_filters.hasOwnProperty(i)) {
									dependent_filter_keys.push(i);
								}
							}

							if($.inArray(filterKey, dependent_filter_keys) !== -1)
							{
								scope.appState.page_filters[key] = typeof scope[key] != 'undefined' && typeof scope[key]['default_value'] != 'undefined'
									?scope[key]['default_value']:'';
							}
						});

        				scope[filterKey].selected_value = filterValue;
    					scope.appState.page_filters[filterKey] = scope[filterKey].selected_value;
						event.preventDefault();
        			}
        		}
				else if(scope[filterKey].filter_type == 'reset')
				{
					//Reset Button
                    var filter_label = (typeof(scope[filterKey].label) != 'undefined') ? scope[filterKey].label : '';
                    var filter_title = (typeof(scope[filterKey].title) != 'undefined') ? scope[filterKey].title : '';
					var filter_icon = (typeof(scope[filterKey].icon) != 'undefined') ? scope[filterKey].icon : 'fa-refresh';
					var optionUl = $(element);

                    optionUl.attr('class', 'btn reset_tab btn-xs btn-mini');
					optionUl.attr('title', filter_title);
					var optionElement = $('<span class="reset"><i class="fa '+filter_icon+'" aria-hidden="true"></i> ' + filter_label +'</span>');
					optionUl.append(optionElement);

					//Bind click
					optionUl.bind("click", function (event) {
						var reset_filters = (typeof(scope[filterKey].reset_filters) != 'undefined') ? scope[filterKey].reset_filters : '';
						$.each(reset_filters, function( key, value ) {
							scope.appState.page_filters[value] = typeof scope[value] != 'undefined' && typeof scope[value]['default_value'] != 'undefined'
								?scope[value]['default_value']:'';
						});
						scope.$apply();
						event.preventDefault();
					});
				}
				else if(scope[filterKey].filter_type == 'checkbox')
				{
					var options_field = (typeof(scope[filterKey].options_field) != 'undefined') ? scope[filterKey].options_field : '';
					var configOptions = (typeof(scope[filterKey][options_field]) != 'undefined') ? scope[filterKey][options_field]: {};
					var first_item_checked = (typeof(scope[filterKey].first_item_checked) != 'undefined') ? scope[filterKey].first_item_checked : false;
					var optionUl = $(element);

                    var applySort = false;
                    $.each(configOptions, function(optionKey, optionValue)
                    {
                        if(typeof(optionValue.sort_order) != 'undefined')
                        {
                            applySort = true;
                            return false;
                        }
                    });
                
                    if(applySort)
                    {
                        configOptions = sortObjectProperties(configOptions, 'sort_order');
                    }

					var all_option = {};
					var options = $.extend({}, all_option, configOptions);

					var selected_filters = scope.appState.page_filters[filterKey].split(',');

                    var unchecked_values = [];

					$.each(options, function(optionKey, optionValue)
					{
                        if(applySort == true && typeof(optionValue.selected_key) != 'undefined')
                        {
                            optionKey = optionValue.selected_key;
                        }

						var checked = "";
						if(jQuery.inArray(optionKey, selected_filters) !== -1){
							checked = 'checked';
						}

						var optionElement = $compile('<div class="radio"><div class="checkbox_block" style="width:25px;display:inline-block;"><input ichecks '+checked+' class="icheck"  type="checkbox" value="' + optionKey + '"></div>'+
							'<label>' + optionValue.label + '</label></div>')(scope);

						optionElement.find('input').on('ifChecked', function(event){
							var value = $(this).val();
							var selected_filters = scope.appState.page_filters[filterKey].split(',');

							if(jQuery.inArray(value, selected_filters) === -1){
								var filters = scope.appState.page_filters[filterKey];
								scope.appState.page_filters[filterKey] = (filters == "")?value:filters+","+value
								scope.$apply();
							}
							event.preventDefault();
						});
						optionElement.find('input').on('ifUnchecked', function(event){
							var value = $(this).val();
                            unchecked_values.push(value);
							var selected_filters = scope.appState.page_filters[filterKey].split(',');

							if(jQuery.inArray(value, selected_filters) !== -1){
                                scope.appState.unchecked_values = unchecked_values;
								var filters = jQuery.grep(selected_filters, function(val) {
									return val != value;
								});
								filters = filters.join();
								scope.appState.page_filters[filterKey] = filters;
								scope.$apply();
							}
							event.preventDefault();
						});


						//add the select all
						if(optionKey == '')
						{
							optionUl.prepend(optionElement);
						}
						//add everthing else
						else
						{
							optionUl.append(optionElement);
						}

						//set initial value
						if(optionKey == scope[filterKey].selected_value)
						{
							//$(element).find('span:eq(0)').html(optionValue.label);
						}

					});

                    //Scroll to the top of the page
                    if(typeof(scope[filterKey].scrollUpOnSubmit) != 'undefined' && scope[filterKey].scrollUpOnSubmit != ''){
                        $('html, body').animate({scrollTop : 0},800);
                    }
				}
                else if(scope[filterKey].filter_type == 'radio')
                {
                    var options_field = (typeof(scope[filterKey].options_field) != 'undefined') ? scope[filterKey].options_field : '';
                    var configOptions = (typeof(scope[filterKey][options_field]) != 'undefined') ? scope[filterKey][options_field]: {};
                    var optionUl = $(element);

                    var applySort = false;
                    $.each(configOptions, function(optionKey, optionValue)
                    {
                        if(typeof(optionValue.sort_order) != 'undefined')
                        {
                            applySort = true;
                            return false;
                        }
                    });
                
                    if(applySort)
                    {
                        configOptions = sortObjectProperties(configOptions, 'sort_order');
                    }
                    //add select all to
                    //var all_option = {"" : {'label' : scope[filterKey].label}}
                    var all_option = {};
                    var options = $.extend({}, all_option, configOptions);

					$.each(options, function(optionKey, optionValue)
					{
                        if(applySort == true && typeof(optionValue.selected_key) != 'undefined')
                        {
                            optionKey = optionValue.selected_key;
                        }

						var selected_filter = scope.appState.page_filters[filterKey];

						var checked = "";
						if(optionKey == selected_filter){
							checked = 'checked';
						}
						var optionElement = $compile('<div class="radio"><div style="width:25px;display:inline-block;"><input ichecks '+checked+' class="icheck" type="radio" name="'+filterKey+'" value="'+optionKey+'" ></div>'+
							'<label>' + optionValue.label + '</label></div>')(scope);

						optionElement.find('input').on('ifChanged', function(event){
							var value = $(this).val();
							scope.appState.page_filters[filterKey] = value;
							scope.$apply();
							event.preventDefault();
						});

						//add the select all
						if(optionKey == '')
						{
							optionUl.prepend(optionElement);
						}
						//add everthing else
						else
						{
							optionUl.append(optionElement);
						}

						//set initial value
						if(optionKey == scope[filterKey].selected_value)
						{
							//$(element).find('span:eq(0)').html(optionValue.label);
						}
					});
                }
                else if(scope[filterKey].filter_type == 'buttonset')
                {
                    var options_field = (typeof(scope[filterKey].options_field) != 'undefined') ? scope[filterKey].options_field : '';
                    var configOptions = scope[filterKey][options_field];
                    var optionUl = $(element);

                    //if no options are available, hide it
                    if(jQuery.isEmptyObject(configOptions))
                    {
                        $(element).addClass('display-none');
                        //reset the filter value
                        if(typeof(scope.appState.page_filters[filterKey]) != 'undefined' && scope.appState.page_filters[filterKey] != '')
                        {
                            scope.appState.page_filters[filterKey] = '';
                            scope.$apply();
                        }
                    }
                    else
                    {
                        //add select all to
                        var all_option = {};
                        if(typeof(scope[filterKey].no_select_all_option) != 'undefined' && scope[filterKey].no_select_all_option == true)
                        {
                            all_option = {};
                        }
                        else
                        {
                            all_option = {"" : {'label' : scope[filterKey].label}}
                        }

                        var applySort = false;
                        $.each(configOptions, function(optionKey, optionValue)
                        {
                            if(typeof(optionValue.sort_order) != 'undefined')
                            {
                                applySort = true;
                                return false;
                            }
                        });

                        if(applySort)
                        {
                            configOptions = sortObjectProperties(configOptions, 'sort_order');
                        }

                        var options = $.extend({}, all_option, configOptions);

                        $.each(options, function(optionKey, optionValue)
                        {
                            if(applySort == true && typeof(optionValue.selected_key) != 'undefined')
                            {
                                optionKey = optionValue.selected_key;
                            }

                            if(typeof(optionValue.html_rendering) != 'undefined' && optionValue.html_rendering === false)
                            {
                                return true;
                            }

                            // var optionElement = $('<li><a href="javascript:void(0);">' + optionValue.label + '</a></li>');
                            var item_icon = typeof optionValue.icon_class != 'undefined' ? '<i class="' + optionValue.icon_class + '"></i> &nbsp; ':'';
                            var optionElement = $('<div class="col-xs-4 no-padding"><a href="javascript:void(0);" class="footer_item" href="#">' + item_icon + optionValue.label + '</a></div>');
                            optionElement.find('a').bind("click", function (event) {
                                scope[filterKey].selected_value = optionKey;
                                scope.appState.page_filters[filterKey] = scope[filterKey].selected_value;
                                $(element).find('a').removeClass('active');
                                $(this).addClass('active');
                                scope.$apply();
                                event.preventDefault();
                            });

                            //add the select all
                            if(optionKey == '')
                            {
                                optionUl.prepend(optionElement);
                            }
                            //add everthing else
                            else
                            {
                                optionUl.append(optionElement);
                            }

                            //set initial value
                            if(optionKey == scope[filterKey].selected_value)
                            {
                                // $(element).find('span:eq(0)').html(optionValue.label);
                                $(element).find('a:eq(0)').addClass('active');
                            }

                        });
                    }
                }
                else if(scope[filterKey].filter_type == 'list')
                {
                    var options_field = (typeof(scope[filterKey].options_field) != 'undefined') ? scope[filterKey].options_field : '';
                    var configOptions = scope[filterKey][options_field];
                    var optionUl = $(element);

                    //if no options are available, hide it
                    if(jQuery.isEmptyObject(configOptions))
                    {
                        $(element).addClass('display-none');
                        //reset the filter value
                        if(typeof(scope.appState.page_filters[filterKey]) != 'undefined' && scope.appState.page_filters[filterKey] != '')
                        {
                            scope.appState.page_filters[filterKey] = '';
                            scope.$apply();
                        }
                    }
                    else
                    {
                        //add select all to
                        var all_option = {};
                        if(typeof(scope[filterKey].no_select_all_option) != 'undefined' && scope[filterKey].no_select_all_option == true)
                        {
                            all_option = {};
                        }
                        else
                        {
                            all_option = {"" : {'label' : scope[filterKey].label}}
                        }

                        var applySort = false;
                        $.each(configOptions, function(optionKey, optionValue)
                        {
                            if(typeof(optionValue.sort_order) != 'undefined')
                            {
                                applySort = true;
                                return false;
                            }
                        });

                        if(applySort)
                        {
                            configOptions = sortObjectProperties(configOptions, 'sort_order');
                        }

                        var options = $.extend({}, all_option, configOptions);

                        $.each(options, function(optionKey, optionValue)
                        {
                            if(applySort == true && typeof(optionValue.selected_key) != 'undefined')
                            {
                                optionKey = optionValue.selected_key;
                            }

                            if(typeof(optionValue.html_rendering) != 'undefined' && optionValue.html_rendering === false)
                            {
                                return true;
                            }

                            var item_icon = typeof optionValue.icon_class != 'undefined' ? '<i class="' + optionValue.icon_class + '"></i> &nbsp; ':'';
                            var selected_filter = scope.appState.page_filters[filterKey];
                            var selected = "";
                            if(optionKey == selected_filter){
                                selected = 'active';
                            }
                            var optionElement = $('<li class=""><a href="javascript:void(0);" class="nav-item '+selected+'" href="#">' + item_icon + optionValue.label + '</a></li>');

                            optionElement.find('a').bind("click", function (event) {
                                scope[filterKey].selected_value = optionKey;
                                scope.appState.page_filters[filterKey] = scope[filterKey].selected_value;
                                $(element).find('a').removeClass('active');
                                $(this).addClass('active');
                                scope.$apply();
                                event.preventDefault();
                            });

                            //add the select all
                            if(optionKey == '')
                            {
                                optionUl.prepend(optionElement);
                            }
                            //add everthing else
                            else
                            {
                                optionUl.append(optionElement);
                            }
                        });

                        //Scroll to the top of the page
                        if(typeof(scope[filterKey].scrollUpOnSubmit) != 'undefined' && scope[filterKey].scrollUpOnSubmit != ''){
                            $('html, body').animate({scrollTop : 0},800);
                        }
                    }
                }
        	}
        }
    };
}

function sortObjectProperties(obj, sortValue){
    var keysSorted = Object.keys(obj).sort(function(a,b){ return obj[a][sortValue]-obj[b][sortValue]; });
    var objSorted = [];
    $.each(keysSorted, function(key, val)
    {
        obj[val]['selected_key'] = val;
        objSorted.push(obj[val]);       
    });
    return objSorted;
}

function notaccessible()
{
	return {
	        restrict: 'A',
	        link: function(scope, element, attrs) {
	        	var element_id = (typeof(attrs['id']) != 'undefined') ? attrs['id'] : null;
	        	if(element_id !== null && typeof(scope[element_id]) != 'undefined' && typeof(scope[element_id].hide_type) != 'undefined')
		        {
	        		if(scope[element_id].hide_type == 'display_none')
	        		{
	        			$(element).css('display', 'none');
	        		}
		        }
	        	else
	        	{
	        		$(element).css('visibility', 'hidden');
	        	}
	        }
	}
}

function permittedAattribute($compile)
{
	return {
	        restrict: 'A',
	        priority: 10000,
	        link: {
		        	pre : function(scope, element, attrs) {

			           var element_id = (typeof(attrs['id']) != 'undefined') ? attrs['id'] : null;
			           var attribute_type = (typeof(attrs['permittedAttribute']) != 'undefined') ? attrs['permittedAttribute'] : null;

			           //check if the filter is a page filter available in app scope, if then skip it as the data for this will be available only when init_page request is complete
			           if(typeof(scope.app_scope_page_filters[element_id]) != 'undefined')
			           {
			        	   //register event listener, if not registered already
			        	   if(scope.app_scope_page_filters_listener === false)
			        	   {
			        		   scope.app_scope_page_filters_listener = true;
			        		   scope.$parent.$on('appScopefilterUpdate', function(event, args) {

			        			   //data recieved for filter, compile this now.
			        			   var filterKey = typeof(args.filter_key) != 'undefined' ? args.filter_key : null;
			        			   var filterValue = typeof(args.filter_value) != 'undefined' ? args.filter_value : null;

			        			   if(filterKey != null && filterValue != null)
			        			   {
			        				   if(typeof(scope.app_scope_page_filters[filterKey].directive_html_template) != 'undefined' && scope.app_scope_page_filters[filterKey].directive_html_template != '')
				        			   {
				        					//change id to address duplicate element
											$('#'+filterKey).attr('id', filterKey + '_remove');

											//insert the new element
											$(scope.app_scope_page_filters[filterKey].directive_html_template).insertAfter($('#'+filterKey+ '_remove'));

											//remove original element
											$('#'+filterKey+ '_remove').remove();
				        			   }

			        				   //display element and compile
			        				   $compile($('#'+filterKey))(scope);
			        			   }
			        		   });
			        	   }

			        	   //store the original html template for re-use
			        	   if(typeof(scope.app_scope_page_filters[element_id].directive_html_template) == 'undefined')
			        	   {
			        		   scope.app_scope_page_filters[element_id].directive_html_template = (typeof($('#'+element_id)) != 'undefined' && typeof($('#'+element_id)[0]) != 'undefined') ?  $('#'+element_id)[0].outerHTML : '';
			        	   }

			        	   //if scope is not avaialble yet, do nothing and wait
			        	   if(typeof(scope[element_id]) == 'undefined')
			        	   {
			        		   return false;
			        	   }
			           }

			           //if not available in scope (not available for experience/user or not defined), remove it
			           if(typeof(scope[element_id]) == 'undefined')
			           {
			        	   $('#'+element_id).remove();
			        	   return false;
			           }


			           //check if this is in a hidden container (e.g. tab content)
			           var skip_permission_check = $("#"+element_id).closest('[tab-container]');
			           if(skip_permission_check.length > 0)
			           {
			        	   return false;
			           }

			           if(element_id !== null && typeof(scope[element_id]) != 'undefined')
			           {
			        	   if(typeof(scope[element_id].not_accessible) != 'undefined' && scope[element_id].not_accessible == true)
			        	   {
			        		   $('#'+element_id).attr('notaccessible', '');
			        	   }
			        	   else
			        	   {
			        		   $('#'+element_id).attr(attribute_type, '');
			        	   }

			        	   $('#'+element_id).removeAttr('permitted-attribute');
			        	   $compile(element)(scope);
			           }
		        }
	       }
	}
}

function showloading($timeout)
{
	return {
	        restrict: 'A',
	        link: function(scope, element, attrs) {
	        	$timeout(function() {

	        		var checkStatusId = (typeof(attrs['showloading']) != 'undefined') ? attrs['showloading'] : null;

	        		if(checkStatusId != null && typeof(scope[checkStatusId]) != 'undefined'
	        			&& typeof(scope[checkStatusId].dataLoading) != 'undefined' && scope[checkStatusId].dataLoading == true)
	        		{

	        			//show loading
	        			$(element).prepend('<div class="component-loading" style="height:' + $(element).height() + 'px;width:' + $(element).width() + 'px"><div class="spinner"><div class="rect1"></div><div class="rect2"></div><div class="rect3"></div><div class="rect4"></div><div class="rect5"></div></div></div>');

	        			//check for change (data loaded)
	        			var unregister = scope.$watch(checkStatusId + '.dataLoading', function () {
	        				if(typeof(scope[checkStatusId].dataLoading) == 'undefined' || scope[checkStatusId].dataLoading == false)
	        				{
	        					//remove loading
	        					$(element).find('.component-loading').remove();
	        					unregister();//remove watch
	        				}
	        			});
	        		}
	        		else
	        		{
	        			//remove loading if any
	        			$(element).find('.component-loading').remove();
	        		}
	        	});
	        }
	}
}

/**
 * @hideExportToMobileDevice - Directive for hiding export button to mobile browsers
 */

function hideExportToMobileDevice() {
    return {
        restrict: 'A',
        controller: function($scope, $element) {
    		if (/Mobi/.test(navigator.userAgent))
    		{
    			$element.hide();
        	}
        }
    };
};

/**
 * @renderMultipleTable - Directive for rendering a normal data block
 */
function renderMultipleTable($compile,$timeout) {
	return {
		restrict: 'A',
		link: function (scope, element, attrs,ctrl) {
			var blockId = attrs.id;

			var unregister = scope.$watch(blockId + '.data', function () {
				if(typeof(scope[blockId].data) !== 'undefined')
				{
					//construct block body
                    var html = '';
                    var blockData = scope[blockId].data;
                    if(typeof(blockData.data) !== 'undefined')
                	{
                    	angular.forEach(blockData.data, function(row, row_key)
                        {
                    		var rank = row_key+1;
                    		html += '<div class="col-xs-12 col-sm-12 col-md-4 col-lg-4">';
                    		html += '<table class="table table-striped table-bordered table-condensed datatable-grid ng-scope" cellspacing="0" width="100%">';
                    		html += '<tr><td rowspan="3" class="home_priority_rank dt-center" width="10%">'+rank+'</td>';
                    		html += '<td colspan="3" class="main_head_sub">'+row.name+'</td></tr>';
                    		html += '<tr class="color_grey"><td class="dt-center">Dealer</td><td class="dt-center">National</td><td class="dt-center">Top Dealer</td></tr>';
                    		html += '<tr><td class="dt-center">'+row.dealer+'</td><td class="dt-center">'+row.national+'</td><td class="dt-center">'+row.top_dealer+'</td></tr>';
                    		html += '</table>';
                    		html += '</div>';
                        });
                    	$(element).html(html);
                	}
				}
			});
		}
	}
}

/**
 * Recursively iterate over a set of elements of a tree
 * @param  {object} RecursionHelper Manually compiles the element, fixing the recursion loop.
 * @return {object}                 The partiate template list structure
 */
function listItemRecursion(RecursionHelper) {
    return {
        restrict: "E",
        scope: {
            tree: '=', 
            topParent: '=',
            onNodeClick: '&',
            topFunc: '=',
            isItemSelected: '&',
            topSelectedFunc: '=',
        },
        template: '<ul class="list-group"><li ng-repeat="t in tree"><a class="list-group-item {{(isItemSelected({node: t, parent: topParent})) ? \'selected\' : \'\'}}" href="javascript:void(0)" ng-click="onNodeClick({node: t, parent: topParent});">{{t.label}} <i class="fa fa-fw {{(isItemSelected({node: t, parent: topParent, mode: \'lastSelect\'})) ? \'fa-check selected\' : \'\'}}"></i></a><listItemRecursion tree="t.value" top-parent="topParent" on-node-click="topFunc(node, parent)" top-func="topFunc"  is-item-selected = "topSelectedFunc(node)" top-selected-func="topSelectedFunc"></listItemRecursion></li></ul>',
        compile: function(element) {
            // Use the compile function from the RecursionHelper,
            // And return the linking function(s) which it returns
            return RecursionHelper.compile(element);
        },
        
    };
}
/**
 * @reasonCode - Directive for rendering a reason code data block
 */
function reasonCode($compile,$timeout) {
    return {
        restrict: 'A',
        link: function (scope, element, attrs,ctrl) {
            var blockId = attrs.id;

            var unregister = scope.$watch(blockId + '.data', function () {
                if(typeof(scope[blockId].data) !== 'undefined')
                {
                    //construct block body
                    var html = '';
                    var blockData = scope[blockId].data;
                    angular.forEach(blockData, function(row, row_key)
                    {
                        html += '<tr><td>'+row.label+'</td>';
                        html += '<td class="text-center">'+row.value+'</td></tr>';
                    });
                    $(element).find('tbody').html(html);
                }
            });
        }
    }
}

/**
 * @reasonCode - Directive for rendering a reason code data block
 */
function importanceRanking($compile,$timeout) {
	return {
		restrict: 'A',
		link: function (scope, element, attrs,ctrl) {
			var blockId = attrs.id;

			var unregister = scope.$watch(blockId + '.data', function () {
				if(typeof(scope[blockId].data) !== 'undefined')
				{
					//construct block body
                    var html = '';
                    var blockData = scope[blockId].data;
                	angular.forEach(blockData, function(row, row_key)
                    {
                		html += '<tr><td class="text-center">'+row.rank+'</td>';
                		html += '<td>'+row.label+'</td></tr>';
                    });
                    $(element).find('tbody').html(html);
				}
			});
		}
	}
}

/**
*   Directive for reading file input
*/
function fileInput($parse)
{
    return {
        restrict: 'A',
        link: function(scope, elmement, attrs) {
            elmement.bind('change', function(){
                scope.extension_label = scope.$parent.$parent.extension_label;
                scope.extension_error = scope.$parent.$parent.extension_error;
                scope.file_size_error = scope.$parent.$parent.file_size_error;
                $parse(attrs.fileInput).assign(scope, scope.$parent.$parent.files);
                scope.$apply();
            })
        }
    }
}

/**
 * @liveComments - Directive for rendering the live comments widget
 */
function liveComments($compile,$timeout) {
    return {
        restrict: 'A',
        link: function (scope, element, attrs,ctrl) {
            var componentId = attrs.id;
            var unregister = scope.$watch(componentId + '.data', function () {
                if(typeof(scope[componentId]) !== 'undefined' && typeof(scope[componentId].data) !== 'undefined')
                {
                    //construct html body
                    var html = '<div class="row wrapper animated fadeInRight">';
                    var componentData = scope[componentId].data;
                    var last_item_timestamp = null;

                    /*var header_class = '';
                    if(typeof(scope[componentId].config.header_class) !== 'undefined')
                    {
                        header_class = scope[componentId].config.header_class;
                    }*/

                    var i = 0;
                    angular.forEach(componentData, function(item, itemKey){
                        if(i == 0)
                        {
                            last_item_timestamp = item.time_stamp;
                        }
                        //Add table header data
                        html += '<div class="col-xs-12 col-sm-12 col-md-12">'+
                                    '<div class="post-heading">'+item.title+' <i class="fa fa-fw fa-circle '+item.color+'"></i></div>'+
                                    '<div class="post default">'+
                                        '<span class="arrow bottom"></span>'+
                                        '<p>'+item.comment+'</p>'+
                                        (typeof item.experiance != 'undefined'?'<span class="label label-default"><i class="fa fa-fw fa-file-text-o"></i> '+item.experiance+'</span>':'')+
                                    '</div>'+
                                    '<div class="post-details">'+
                                        '<div class="time">'+item.date_time+'</div>'+
                                        '<div class="author">'+item.customer_name+'</div>'+
                                    '</div>'+
                                '</div>';
                        
                        i++;
                    });
                    html += '</div>';
                    $(element).html(html);
                    $(element).attr('data-last_item_timestamp', last_item_timestamp);
                }
            });
        }
    }
}

/**
 * @genericTable - Directive for rendering a normal html table
 */
function genericTable($compile,$timeout) {
    return {
        restrict: 'A',
        link: function (scope, element, attrs,ctrl) {
            var tableId = attrs.id;
            var unregister = scope.$watch(tableId + '.data', function () {
                //Populate the header
                var headers = '';

                if(typeof(scope[tableId].data) !== 'undefined')
                {
                    var html = '';
                    var tableData = scope[tableId].data;
                    var headerData = tableData.header;
                    var rowData = tableData.rows;
                    //construct table header
                    angular.forEach(headerData, function(row, row_key){
                        //
                        header_class = '';
                        //Add table header data
                        header_prefix_html = '<tr class="'+header_class+'">';
                        header_body = '';
                        var is_row_hidden = false;
                        angular.forEach(row, function(cell, cell_key){
                            var span = cell != null && typeof cell.span != 'undefined'?cell.span:'';
                            var v_span = cell != null && typeof cell.v_span != 'undefined'?cell.v_span:'';
                            var label = cell != null && typeof cell.label != 'undefined'?cell.label:'';
                            var is_hidden = cell != null && typeof cell.hide != 'undefined'?cell.hide:false;
                            var class_name = (cell != null && typeof cell.class_name !='undefined')?cell.class_name:'';
                            if(is_hidden)
                            {
                                is_row_hidden = true;
                            }
                            header_body += '<th colspan="'+span+'" class="' + class_name + '" rowspan="'+v_span+'">'+label+'</th>';
                        });
                        header_suffix_html = '</tr>';
                        var new_header_row = header_prefix_html + header_body + header_suffix_html;

                        //If row is not hidden, add the header row
                        if(!is_row_hidden)
                        {
                            headers += new_header_row;
                        }
                        
                    });

                    angular.forEach(rowData, function(row, row_key){
                        //
                        row_class = '';
                        //Add table header data
                        html += '<tr class="'+row_class+'">';
                        
                        angular.forEach(row, function(cell, cell_key){
                            var span = cell != null && typeof cell.span != 'undefined'?cell.span:'';
                            var v_span = cell != null && typeof cell.v_span != 'undefined'?cell.v_span:'';
                            var label = cell != null && typeof cell.label != 'undefined'?cell.label:'';
                            var class_name = (cell != null && typeof cell.class_name !='undefined')?cell.class_name:'';
                            html += '<td colspan="'+span+'" class="' + class_name + '" rowspan="'+v_span+'">'+label+'</td>';
                        });
                        html += '</tr>';
                    });

                    $(element).find('thead').html(headers);
                    $(element).find('tbody').html(html);
                }
            });
        }
    }
}

function myDatePicker ($timeout) {
    return {
        restrict: 'A',
        require: '?ngModel',
        link: function (scope, element, attrs, ngModelController) {
            var to_date = attrs['toDate'];
            var from_date = typeof attrs['fromDate'] != 'undefined' ? attrs['fromDate'] : '';
            var start_date = from_date == "none" ? null : (from_date == '' ? new Date() : new Date(from_date * 1000));
            var end_date = new Date(to_date * 1000);

            // Private variables
            var datepickerFormat = 'dd/mm/yy',
                momentFormat = 'D/M/YYYY',
                datepicker,
                elPicker;

            // Init date picker and get objects http://bootstrap-datepicker.readthedocs.org/en/release/index.html
            datepicker = element.datepicker({
                autoclose: true,
                keyboardNavigation: false,
                todayHighlight: true,
                dateFormat: datepickerFormat,
                minDate:start_date,
                maxDate: end_date,
                onSelect: function(d,i){
                    if(d !== i.lastVal){
                        $(this).change();
                    }
                }
            });

            $timeout(function() {
                // console.log("datepicker: onLoad event registered");

                elPicker = datepicker.data('datepicker').picker;

                // Adjust offset on show
                datepicker.on('show', function (evt) {
                    elPicker.css('left', parseInt(elPicker.css('left')) + +attrs.offsetX);
                    elPicker.css('top', parseInt(elPicker.css('top')) + +attrs.offsetY);
                });

                // Only watch and format if ng-model is present https://docs.angularjs.org/api/ng/type/ngModel.NgModelController
                if (ngModelController) {

                    // So we can maintain time
                    var lastModelValueMoment;

                    ngModelController.$formatters.push(function (modelValue) {
                        // Get view value (String) from model value (Date)
                        var viewValue,
                        m = moment(modelValue, momentFormat, true);
                        if (modelValue && m.isValid()) {
                            // Valid date obj in model
                            lastModelValueMoment = m.clone(); // Save date (so we can restore time later)
                            viewValue = m.format(momentFormat);
                        }

                        if(viewValue){
                            // Update picker
                            element.datepicker('update', viewValue);
                        }
                        
                        // Update view
                        return viewValue;
                    });

                    ngModelController.$parsers.push(function (viewValue) {
                        // Get model value (Date) from view value (String)
                        var modelValue = undefined,
                        m = moment(viewValue, momentFormat, true);
                        if (viewValue && m.isValid()) {
                            // Valid date string in view
                            if (lastModelValueMoment) { // Restore time
                                m.hour(lastModelValueMoment.hour());
                                m.minute(lastModelValueMoment.minute());
                                m.second(lastModelValueMoment.second());
                                m.millisecond(lastModelValueMoment.millisecond());
                            }
                            modelValue = m.format(momentFormat);
                        }
                        // Update model
                        return modelValue;
                    });

                    datepicker.on('changeDate', function (evt) {
                        // Only update if it's NOT an <input> (if it's an <input> the datepicker plugin trys to cast the val to a Date)
                        if (evt.target.tagName !== 'INPUT') {
                            ngModelController.$setViewValue(moment(evt.date).format(momentFormat)); // $seViewValue basically calls the $parser above so we need to pass a string date value in
                            ngModelController.$render();
                        }
                    });
                }
            }); 
        }
    };
}

function inputTypeFileDirective () {
    return {
        restrict: 'E',
        require: '?ngModel',
        link: function (scope, element, attrs, ngModel) {
            if (attrs.type !== 'file' || typeof attrs.validateFile === 'undefined' || !angular.isDefined(ngModel)) {
                return;
            }

            element.on('change', updateModelWithFile);
            scope.$on('$destroy', function () {
                element.off('change', updateModelWithFile);
            });

            if (attrs.maxsize) {
                var maxsize = parseInt(attrs.maxsize);
                ngModel.$validators.maxsize = function(modelValue, viewValue) {
                    var value = modelValue || viewValue;
                    if (!angular.isArray(value)) {
                        value = [value];
                    }
                    for (var i = value.length - 1; i >= 0; i--) {
                        if (value[i] && value[i].size && value[i].size > maxsize) {
                            return false;
                        }
                    }
                    return true;
                };
            }

            if (attrs.accept) {
                var accept = attrs.accept.split(',');
                ngModel.$validators.accept = function(modelValue, viewValue) {
                    var value = modelValue || viewValue;
                    if (!angular.isArray(value)) {
                        value = [value];
                    }
                    for (var i = value.length - 1; i >= 0; i--) {
                        if (value[i] && accept.indexOf(value[i].type) === -1) {
                            return false;
                        }
                    }
                    return true;
                };
            }

            if (attrs.validextensions) {
                var validFormats = attrs.validextensions.toLowerCase();
                validFormats = validFormats.split(',');
                ngModel.$validators.validextensions = function(modelValue, viewValue) {
                    var value = modelValue || viewValue;
                    if (!angular.isArray(value)) {
                        value = [value];
                    }
                    for (var i = value.length - 1; i >= 0; i--) {
                        var filename = value[i] && value[i].name?value[i].name:'';
                        var ext = '';
                        if(filename){
                            ext = filename.substr(filename.lastIndexOf('.')+1).toLowerCase();
                        }
                        if (value[i] && validFormats.indexOf(ext) === -1) {
                            return false;
                        }
                    }
                    return true;
                };
            }

            function updateModelWithFile (event) {
                var files = event.target.files;
                if (!angular.isDefined(attrs.multiple)) {
                    files = files[0];
                } else {
                    files = Array.prototype.slice.apply(files);
                }
                ngModel.$setViewValue(files, event);

                //Trigger the custom onchange function if any
                if(attrs.customOnChange){
                    scope.$eval(attrs.customOnChange);
                }
            }
        }
    };
}

function switcheryDirective($window, $timeout, $log, $parse) {

    /**
     * Initializes the HTML element as a Switchery switch.
     *
     * @TODO add a way to provide options for Switchery
     * $timeout is in place as a workaround to work within angular-ui tabs.
     *
     * @param scope
     * @param elem
     * @param attrs
     */
    function linkSwitchery(scope, elem, attrs, ngModel) {
        if (!ngModel) return false;

        var switcher;
        var options = {};
        try {
            options = $parse(attrs.uiSwitch)(scope);
        }
        catch (e) { }

        function setSwitchery() {
            if (switcher) {
                angular.element(switcher.switcher).remove();
            }
            switcher = new $window.Switchery(elem[0], options);
            var element = switcher.element;
            element.checked = scope.initValue;
            switcher.setPosition(false);
            element.addEventListener('change', function (evt) {
                scope.$apply(function () {
                    ngModel.$setViewValue(element.checked);
                });
            });
        }

        scope.$watch("initValue", function () {
            setSwitchery();
        });


        $timeout(function() {
            setSwitchery();
        }, 0);

    }
    return {
        require: 'ngModel',
        restrict: 'AE',
        scope : {initValue : '=ngModel'},
        link: linkSwitchery
    }
}

function icheckAdvanced($timeout, $parse) {
    return {
      restrict: 'A',
      require: '?ngModel',
      link: function(scope, element, attr, ngModel) {
        $timeout(function() {
          var value = attr.value;
        
          function update(checked) {
            if(attr.type==='radio') { 
              ngModel.$setViewValue(value);
            } else {
              ngModel.$setViewValue(checked);
            }
          }
          scope.$watch(attr.ngChecked, function(checked) {
            if(typeof checked === 'undefined') checked = !!ngModel.$viewValue;
            update(checked)
          }, true);

          scope.$watch(attr.ngModel, function(model) {
            $(element).iCheck('update');
          }, true);

          scope.$watch(attr['ngDisabled'], function (newValue) {
            $(element).iCheck(newValue ? 'disable' : 'enable');
            $(element).iCheck('update');
          })

          return $(element).iCheck({
            checkboxClass: attr.checkboxClass || 'icheckbox_flat-grey',
            radioClass: attr.radioClass || 'iradio_flat-grey',
            increaseArea: '20%'
          }).on('ifChanged', function(e) {
            scope.$apply(function() {
              update(e.target.checked);
            });
          });

        })
      }
    }
  }


/*
 * Pass functions to module
 */
angular
    .module('potentiateApp')
    .directive('pageTitle', pageTitle)
    .directive('widgetToggle', widgetToggle)
    .directive('widgetHeaderToggle', widgetHeaderToggle)
    .directive('widgetClose', widgetClose)
    .directive('toggleLeftSidebar', toggleLeftSidebar)
    .directive('toggleRightSidebar', toggleRightSidebar)
    .directive('closeRightSidebar', closeRightSidebar)
    .directive('navToggleSub', navToggleSub)
    .directive('slider', slider)
    .directive('css3animate', css3animate)
    .directive('ichecks', ichecks)
    .directive('skycon', skycon)
    .directive('fullscreenMode', fullscreenMode)
    .directive('fullscreenWidget', fullscreenWidget)
    .directive('listGroupSelector', listGroupSelector)
    .directive('buttonGroupSelector', buttonGroupSelector)
    .directive('pagefilter', pagefilter)
    .directive('notaccessible', notaccessible)
    .directive('permittedAttribute', permittedAattribute)
    .directive('showloading', showloading)
    .directive('simpletable', simpleTable)
    .directive('renderdatablock', renderDataBlock)
    .directive('customFunction', customFunction)
    .directive('hideExportToMobileDevice', hideExportToMobileDevice)
    .directive('rendermultipletable', renderMultipleTable)
    .directive("listitemrecursion", listItemRecursion)
    .directive('reasoncode', reasonCode)
    .directive('importanceranking', importanceRanking)
    .directive('fileInput', fileInput)
    .directive('livecomments', liveComments)
    .directive('genericTable', genericTable)
    .directive('renderactionplanform', renderActionPlanForm)
    .directive('renderactionplanactionsection', renderActionPlanActionSection)
    .directive('mydatepicker', myDatePicker)
    .directive('input', inputTypeFileDirective)
    .directive('uiSwitch', switcheryDirective)
    .directive('icheckadvanced', icheckAdvanced)
    
